<template>
  <div id="app">
      <router-view/>
  </div>
</template>

<script>
    export default {
    }
</script>

<style lang="scss">
  @font-face {
    font-family: 'Open Sans';
    src: url('./assets/fonts/OpenSans-Regular.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
  }
  @font-face {
      font-family: 'Open Sans - Semi Bold';
      src: url('./assets/fonts/OpenSans-Semibold.ttf') format('truetype');
      font-weight: normal;
      font-style: normal;
  }
  @font-face {
    font-family: 'Optimal C';
    src: url('./assets/fonts/OptimalC.otf') format('opentype');
    font-weight: normal;
    font-style: normal;
  }
  #app {
    display: flex;
    justify-content: center;
    width:100%;
    margin: 0 auto;
  }
  body {
    margin: 8px 0;
  }

</style>
